import { render, staticRenderFns } from "./specialDetails.vue?vue&type=template&id=5b00d91f&scoped=true&"
import script from "./specialDetails.vue?vue&type=script&lang=js&"
export * from "./specialDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00d91f",
  null
  
)

export default component.exports